export default __webpack_public_path__ + "static/media/15.badee3a7.png";